



























































































































































import { Component, Vue } from "vue-property-decorator";
import { ACTION_FETCH_PROPOSALS } from "@/store/actions-types";
import { ProposalModelI, TimelineI } from "@/models/admin/ProposalModel";
import { GET_PROPOSALS } from "@/store/getters-types";
import Markdown from "@/components/Markdown.vue";
import CommentAuthorIndicator from "@/components/CommentAuthorIndicator.vue";
import { CPTCommentI } from "@/models/cpt/CPTCommentI";
import { UserRoles } from "@/models/auth/AuthenticatedUser";
import DashboardSkeleton from "@/components/DashboardSkeleton.vue";
import Timeline from "@/components/Timeline.vue";

@Component({
  components: {
    Timeline,
    DashboardSkeleton,
    Markdown,
    CommentAuthorIndicator,
  },
})
/**
 * Lists all proposed cpt's for moderation
 */
export default class Dashboard extends Vue {
  public isLoading = false;

  /**
   * show timeline
   */
  public showTimeline = false;

  /**
   * contains the comment id as key and a bool
   * indicating if the comment collapsible is open or closed
   */
  public expandedCommentMap: { [key: string]: boolean } = {};

  /**
   * load all proposals
   */
  async mounted(): Promise<void> {
    this.isLoading = true;
    await this.$store.dispatch(ACTION_FETCH_PROPOSALS);
    this.isLoading = false;
  }

  /**
   * get proposals from store
   */
  get proposals(): ProposalModelI[] {
    return this.$store.getters[GET_PROPOSALS].proposals || [];
  }

  /**
   * get the timeline elements
   */
  get timeline(): TimelineI[] {
    return this.$store.getters[GET_PROPOSALS].timeline || [];
  }

  /**
   * Check if the last comment was made by an anonymous contributor
   */
  isLatestCommentFromAnon(proposal: ProposalModelI): boolean {
    return this.extractLatestComment(proposal)?.author === UserRoles.ANON;
  }

  /**
   * get the latest comment or null in case there aren't any
   */
  extractLatestComment(proposal: ProposalModelI): CPTCommentI | null {
    if (proposal.comments.length > 0) {
      return proposal.comments[proposal.comments.length - 1];
    }

    return null;
  }

  /**
   * create a unique id for a comment
   */
  constructUniqueCommentId(proposal: ProposalModelI): string {
    return proposal.id + "-" + this.extractLatestComment(proposal)?.id;
  }

  /**
   * add or remove the comment id as key in the
   * collapsible state object
   * The actual value is not needed
   */
  toggleCommentCollapsible(proposal: ProposalModelI): void {
    const id = this.constructUniqueCommentId(proposal);
    if (this.expandedCommentMap[id]) {
      this.$set(this.expandedCommentMap, id, false);
    } else {
      this.$set(this.expandedCommentMap, id, true);
    }
  }

  /**
   * check if a comment is collapsed or not
   */
  isCollapsed(proposal: ProposalModelI): boolean {
    return !(
      this.constructUniqueCommentId(proposal) in this.expandedCommentMap
    );
  }

  /**
   * hide / show timeline
   */
  toggleTimeline(): void {
    this.showTimeline = !this.showTimeline;
  }
}
